var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", {
        class: {
          "frame-advisor__overlay": _vm.isFrameAdvisorRunning,
        },
      }),
      _vm._v(" "),
      _vm.isRoxPanelEnabled && _vm.isFrameAdvisorRunning
        ? _c("rb-rox-panel")
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        ref: "frameadvUi",
        class: {
          "frame-advisor__login-modal--open": _vm.loginIsVisible,
          "frame-advisor--is-running": _vm.isFrameAdvisorRunning,
          "frame-advisor--floating-button": !_vm.isFrameAdvisorRunning,
        },
        style: _vm.frameAdvisorStyle,
        attrs: { id: "frameadv-ui", "data-analytics_available_call": "0" },
      }),
      _vm._v(" "),
      _c("rb-login-panel-and-modal", {
        attrs: { visible: _vm.loginIsVisible, "from-frame-advisor": true },
        on: {
          closed: function ($event) {
            _vm.loginIsVisible = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }